export const AGENT_PROFILE_FIELDS = {
  name: {label: "نام", contentKey: "name"},
  family: {label: "نام خانوادگی", contentKey: "family"},
  photo: {label: "تصویر پروفایل", contentKey: "photo_file_id"},
  about_me: {label: "درباره من", contentKey: "about_me"},
  speciality: {label: "تخصص", contentKey: "speciality"},
  experience: {label: "سابقه کاری", contentKey: "experience"},
  location: {label: "موقعیت مکانی", contentKey: "location"},
  introduction_file: {label: "ویدیوی معرفی", contentKey: "introduction_file_id"},
};

export const CHANGE_STATUS = {
  pending: {label: "در انتظار بررسی", className: "bg-amber-50 text-amber-800 border-amber-200"},
  approved: {label: "تایید شده", className: "bg-emerald-50 text-emerald-800 border-emerald-200"},
  rejected: {label: "رد شده", className: "bg-rose-50 text-rose-800 border-rose-200"},
  withdrawn: {label: "لغو شده", className: "bg-slate-100 text-slate-700 border-slate-200"},
};

export const createAgentProfileForm = content => ({
  name: content?.name ?? "",
  family: content?.family ?? "",
  about_me: content?.about_me ?? "",
  speciality: content?.speciality ?? "",
  experience: content?.experience ?? "",
  province_id: content?.location?.province_id ?? null,
  city_id: content?.location?.city_id ?? null,
});

export const collectPendingAgentProfileFields = pendingRequests => {
  const result = {};
  (pendingRequests ?? []).forEach(request => {
    (request.items ?? []).forEach(item => {
      if (item.status === "pending") {
        result[item.field] = {
          item,
          requestId: request.id,
          proposed: request.proposed?.[AGENT_PROFILE_FIELDS[item.field]?.contentKey],
        };
      }
    });
  });
  return result;
};

const normalizedText = value => String(value ?? "").trim();
const normalizedOptionalNumber = value => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const sameLocation = (left, right) => (
  (left?.province_id ?? null) === (right?.province_id ?? null) &&
  (left?.city_id ?? null) === (right?.city_id ?? null)
);

export const validateAgentProfileForm = form => {
  const errors = {};
  const name = normalizedText(form.name);
  const family = normalizedText(form.family);
  const aboutMe = normalizedText(form.about_me);
  const speciality = normalizedText(form.speciality);

  if (!name) errors.name = "نام الزامی است.";
  if (name.length > 100) errors.name = "نام حداکثر ۱۰۰ نویسه است.";
  if (!family) errors.family = "نام خانوادگی الزامی است.";
  if (family.length > 100) errors.family = "نام خانوادگی حداکثر ۱۰۰ نویسه است.";
  if (aboutMe.length > 20000) errors.about_me = "متن درباره من بیش از حد طولانی است.";
  if (speciality.length > 2000) errors.speciality = "متن تخصص بیش از حد طولانی است.";

  const hasProvince = Boolean(form.province_id);
  const hasCity = Boolean(form.city_id);
  if (hasProvince !== hasCity) {
    errors.location = "استان و شهر باید با هم انتخاب شوند.";
  }

  const experience = normalizedOptionalNumber(form.experience);
  if (form.experience !== "" && (experience === null || experience < 0 || !Number.isInteger(experience))) {
    errors.experience = "سابقه کاری باید یک عدد صحیح و مثبت باشد.";
  }

  return errors;
};

export const buildAgentProfileChanges = (approved, form, pendingFields = {}) => {
  const changes = {};
  const textFields = ["name", "family", "about_me", "speciality"];

  textFields.forEach(field => {
    if (pendingFields[field]) return;
    const value = normalizedText(form[field]);
    if (value !== normalizedText(approved?.[field])) {
      changes[field] = value;
    }
  });

  if (!pendingFields.experience) {
    const experience = normalizedOptionalNumber(form.experience);
    if (experience !== (approved?.experience ?? null)) {
      changes.experience = experience;
    }
  }

  if (!pendingFields.location) {
    const location = form.province_id && form.city_id
      ? {province_id: Number(form.province_id), city_id: Number(form.city_id)}
      : null;
    if (!sameLocation(location, approved?.location)) {
      changes.location = location;
    }
  }

  return changes;
};

export const formatAgentProfileDate = value => {
  if (!value) return "—";
  return new Intl.DateTimeFormat("fa-IR", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
};
